import {PredicateOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DelayParam} from '../../../../../editors/commons/paramModel';
import {ClientRuleAction} from '../../../../ruleActionModel';
import {CsatEditorSubsetsEnum} from './csatEditorState';

export enum CsatEditorActionTypesEnum {
  SET_DELAY_SINCE_TRIGGER = '@@csat_editor/SET_DELAY_SINCE_TRIGGER',
  SET_TAG = '@@csat_editor/SET_TAG',
  SET_RESPONSE = '@@csat_editor/SET_RESPONSE',

  ADD_ACTION = '@@csat_editor/ADD_ACTION',
  UPDATE_ACTION = '@@csat_editor/UPDATED_ACTION',
  DELETE_ACTION = '@@csat_editor/DELETE_ACTION',
}

interface SetDelaySinceTriggerAction {
  type: CsatEditorActionTypesEnum.SET_DELAY_SINCE_TRIGGER;
  payload: DelayParam;
}

interface SetTagAction {
  type: CsatEditorActionTypesEnum.SET_TAG;
  payload: {
    tagId: number;
    subset: CsatEditorSubsetsEnum;
  };
}

interface SetResponseAction {
  type: CsatEditorActionTypesEnum.SET_RESPONSE;
  payload: number;
}

interface AddActionAction {
  type: CsatEditorActionTypesEnum.ADD_ACTION;
  payload: {
    action: ClientRuleAction;
    subset: CsatEditorSubsetsEnum;
  };
}

interface UpdateActionAction {
  type: CsatEditorActionTypesEnum.UPDATE_ACTION;
  payload: {
    predicate: PredicateOf<ClientRuleAction>;
    update(action: ClientRuleAction): ClientRuleAction;
    subset: CsatEditorSubsetsEnum;
  };
}

interface DeleteActionAction {
  type: CsatEditorActionTypesEnum.DELETE_ACTION;
  payload: {
    predicate: PredicateOf<ClientRuleAction>;
    subset: CsatEditorSubsetsEnum;
  };
}

export type CsatEditorSpecificAction =
  | SetDelaySinceTriggerAction
  | SetTagAction
  | SetResponseAction
  | AddActionAction
  | UpdateActionAction
  | DeleteActionAction;
